import {
  useCreateBillingPortalSession,
  useDefaultPaymentMethod,
} from "$/api/payment";
import CreditcardIcon from "$/lib/icons/CreditcardIcon";

const PaymentMethodsList = () => {
  const { data: defaultPaymentMethod, isLoading } = useDefaultPaymentMethod();

  const { mutate: createBillingPortalSession } =
    useCreateBillingPortalSession();

  const formatExpiry = (month?: number | null, year?: number | null) => {
    if (!month || !year) return "";
    return `${month.toString().padStart(2, "0")}/${year}`;
  };

  const handleAddOrEditPaymentMethod = () => {
    createBillingPortalSession({
      returnUrl: window.location.href,
      purpose: "payment_method_management",
    });
  };

  return (
    <div className="mb-2 mt-2">
      <h3 className="mb-1 text-[13px] screen850:text-sm font-semibold text-textColor">
        Moyen de paiement
      </h3>
      <div className="flex flex-col gap-3">
        {isLoading ? (
          <div className="rounded-xl min-h-[58px] border border-border px-4 py-3 text-sm text-textInfo">
            Chargement...
          </div>
        ) : defaultPaymentMethod ? (
          (() => {
            const method = defaultPaymentMethod;
            const label = method.cardBrand ?? "Carte";
            const last4 = method.cardLast4 ? `•••• ${method.cardLast4}` : "";
            const expiry = formatExpiry(
              method.cardExpMonth,
              method.cardExpYear,
            );

            return (
              <div
                key={method.id}
                // TODO: when multiple cards are re-implemented use: `border-secondary-300` instead
                className="relative rounded-xl  border border-border min-h-[50px] py-2.5 px-3"
              >
                <div className="flex w-full items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-info">
                      <CreditcardIcon className="h-4 w-4 text-textInfo" />
                    </div>
                    <span className="text-sm font-semibold text-[#1E1C2D]">
                      {label}
                    </span>
                    {/* <span className="rounded-full bg-secondary-100 px-2 py-1 text-[11px] font-semibold text-secondary-700">
                      Défaut
                    </span> */}
                  </div>
                  <span className="text-sm font-semibold text-textColor">
                    {last4}
                    {expiry ? ` • ${expiry}` : ""}
                  </span>
                </div>
                {/* <div className="absolute -right-3 -top-3 flex h-6 w-6 items-center justify-center rounded-full bg-secondary-300 shadow-md">
                  <SuccessCircleIcon className="h-6 w-6 text-secondary-300" />
                </div> */}
              </div>
            );
          })()
        ) : (
          <div className="flex items-center gap-3 rounded-xl border border-border px-3 py-2.5 min-h-[50px] text-sm font-semibold text-textInfo">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-info">
              <CreditcardIcon className="h-4 w-4 text-textInfo" />
            </div>
            Aucun moyen de paiement enregistré.
          </div>
        )}
      </div>
      {defaultPaymentMethod && (
        <div className="flex w-full justify-end">
          <button
            onClick={handleAddOrEditPaymentMethod}
            className="mt-1 text-xs font-semibold text-textInfo transition hover:text-secondary-300"
          >
            + Ajouter / modifier mon moyen de paiement
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodsList;
